import { Badge, Box } from '@mui/material';
import React from 'react'

export default function UnreadCountBadge({
  count = 0,
  children,
  max = 99,
  anchorOrigin = { vertical: "top", horizontal: "right" },
  overlap = "circular",
  dot = false,
  inline = false,
}) {
  // UnreadToggle用バッジ
  if (inline) {
    if (!count) return null;
    const shown = count > max ? `${max}+` : count;

    const round = true;
    const isPill = !round && shown.length > 1;
    
    return (
      <Box
        component={"span"}
        sx={{
          // 丸 or 楕円を切り替え
          ...(isPill
            ? { px: 0.75, height: 18, lineHeight: "18px", borderRadius: "9999px" } // pill
            : { width: 18, height: 18, lineHeight: "18px", borderRadius: "50%" } // circle
          ),
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          fontWeight: 700,
          bgcolor: "error.main",
          color: "#fff",
          verticalAlign: "middle",
        }}
      >
        {shown}
      </Box>
    )
  }
  // HeaderUnreadButtons用バッジ
  return (
    <Badge
      badgeContent={dot ? null : count}
      variant={dot ? "dot" : undefined}
      color='error'
      overlap={overlap}
      anchorOrigin={anchorOrigin}
      invisible={count === 0}
      max={max}
      sx={{
        "& .MuiBadge-badge": {
          minWidth: 16,
          height: 16,
          fontSize: 10,
          lineHeight: "16px",
          padding: "0 4px",
        },
      }}
    >
      <Box sx={{ display: "inline-flex" }}>{children}</Box>
    </Badge>
  );
}
